// NOTE: Not currently in use but didn't want to delete the file so we can revive later
import { Locales } from '@ratehub/base-ui';

import createBlogCategoryStaticProps from '../functions/createBlogCategoryStaticProps';
import withFrenchLocale from '../functions/withFrenchLocale';
import BlogCategoryPage from '../components/BlogCategoryPage';


const { getStaticPaths, getStaticProps } = createBlogCategoryStaticProps({
    locale: Locales.FRENCH,
    fileName: 'blogCategoryFR', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    path: '/blogue/category', // Array to determine the url - final result is `/${rootPath.join('/')}`
});

export default withFrenchLocale(BlogCategoryPage);
export { getStaticPaths, getStaticProps };
